import { Component, OnInit } from '@angular/core';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { AlertController } from '@ionic/angular';
import { RestApiService } from '../rest-api.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(public alertController: AlertController, public commonFunctions: CommonFunctionsService, public restApi: RestApiService) { }

  ngOnInit() { }

  page() {
    return General_Config.active_page;
  }

  async logoutUser() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: "Are you sure?",
      message: "Do you really want to logout?",
      buttons: [
        {
          text: 'No',
          handler: () => {
            console.log('Confirm No');
          }
        },
        {
          text: 'Yes',
          handler: () => {
            this.restApi.post('logout_staff', {}).subscribe((data: any) => {
              if (data['code'] == 200) {
                window.localStorage.removeItem(General_Config.session_key + 'token');
                this.commonFunctions.goToPage('/login');  
              } else {
                this.commonFunctions.presentAlertConfirm('Information', data['message']);
              }
            }, (error: any) => {
              this.commonFunctions.presentAlertConfirm('Information', error);
            });
          }
        }
      ]
    });
    await alert.present();
  }
}
